module.exports = __webpack_public_path__ + "static/media/a91-logo.892166e5.png";